exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".on-mobile{position:absolute;z-index:1000;top:0;height:0;width:100%;height:100%;background-color:#021b39;display:none;overflow:scroll}@media screen and (max-width:960px){.on-mobile{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-1e074344!./~/postcss-loader!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/OnMobile/OnMobile.vue
// module id = 115
// module chunks = 0